import React from 'react';

import Image_1 from '../../assets/stripe-onboarding_1.png';
import Image_2 from '../../assets/stripe-onboarding_2.png';
import Image_3 from '../../assets/stripe-onboarding_3.png';
import Image_4 from '../../assets/stripe-onboarding_4.png';
import Image_5 from '../../assets/stripe-onboarding_5.png';
import Image_6 from '../../assets/stripe-onboarding_6.png';
import Image_7 from '../../assets/stripe-onboarding_7.png';
import Image_8 from '../../assets/stripe-onboarding_8.png';

import { Loader } from '@/components/Common';
import { paths } from '@/config';
import { Link } from 'react-router-dom';
import { useHowToSalesAccountHooks } from '../../hooks';
import { CopyArea } from './copy-area';
import './style.scss';

const core = () => {
  const {
    data,
    isLoading,
    handleWebSiteCopy,
    website,
    clipboard,
    isError,
  } = useHowToSalesAccountHooks();

  return (
    <div className="a__introduction_howto_sales_account">
      <div className="w__introduction_howto_sales_account">
        <header>Stripeの登録方法について</header>
        <div className="introduction_howto_sales_account-warning">
          <p>
            正しく項目が登録できていないことや、Stripeの案内に沿った対応がされていないことが原因で、Stripeの審査を通過せず、売上金の入金が保留・停止される事例が発生しています。
            <br />
            必ず、下記の手順と入力項目をご確認の上、登録してください。
            <br />
            また、Stripeの登録画面および審査項目は随時変更されるため、画面上に「必要な対応」「申告書を提出」「本人確認」「追加情報の提出」等が表示されている場合は、Stripe画面上の案内を優先してご対応ください。
            <br />
            未対応の場合、売上金の入金が停止されることがあります。
          </p>
        </div>
        <div className="introduction_howto_sales_account-warning">
          <p>
            審査が通らず追加資料を求められた場合、
            <Link to={paths.introduction.faq}>こちら</Link>
            のページをご確認ください
          </p>
        </div>
        <div className="explain">
          マイページの「売上げ受取口座を登録する」ボタンを押すと、Stripeの登録画面が開きます。
          <br />
          FishSale以外でStripeを活用しない場合には、設問に対して次のとおり回答してください。
          <br />
          FishSale以外でもご利用される場合には、設問に従いご回答ください。
        </div>
        <div className="answer_example">
          <p className="introduction_howto_sales_account--step">
            STEP1 基本事項の登録
          </p>
          <p>
            「ビジネスの所在地」は「日本」、「事業形態」は「個人または個人事業主」を選択してください（法人としてご利用の場合は該当の事業形態を選択してください）。
          </p>
          <a href={Image_1} target="_blank" rel="noopener noreferrer">
            <img src={Image_1} loading="lazy" decoding="async" />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP2 個人情報の確認
          </p>
          <p>
            ご本人のお名前・メールアドレス・生年月日・自宅住所・電話番号を入力してください。
            <br />
            本人確認に使用されるため、住民票等の公的書類と一致する正確な情報を入力してください。相違があると審査を通過できず、売上金が入金されません。
          </p>
          <a href={Image_2} target="_blank" rel="noopener noreferrer">
            <img src={Image_2} loading="lazy" decoding="async" />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP3 ビジネスの詳細
          </p>
          <p>
            「ウェブサイト」にはあなたのユーザーページを下記よりコピーし入力してください。
          </p>
          {window.isAuthed && !isLoading && data && (
            <div className="introduction_howto_sales_account--copy">
              <label>
                <span className="textbox-label">ウェブサイト</span>
                <input
                  type="text"
                  className="textbox"
                  value={website}
                  onClick={handleWebSiteCopy}
                  readOnly
                />
              </label>
              <p className="description">クリックするとコピーされます。</p>
              {clipboard.copied && <p className="balloon">コピーしました</p>}
            </div>
          )}
          {isLoading && window.isAuthed && (
            <div className="introduction_howto_sales_account--loader">
              <Loader />
            </div>
          )}
          {!window.isAuthed && (
            <p className="introduction_howto_sales_account-warning">
              ユーザーページを取得するために、
              <a href={paths.before.signin}>ログイン</a>してください
            </p>
          )}
          {window.isAuthed && isError && (
            <p className="introduction_howto_sales_account-warning">
              読み込みに失敗しました。ページを再度読み込んでください。
            </p>
          )}
          <p>「商品の説明」には下記をコピーし入力してください。</p>
          <a href={Image_3} target="_blank" rel="noopener noreferrer">
            <img src={Image_3} loading="lazy" decoding="async" />
          </a>
          <CopyArea label="商品の説明" mb={49}>
            釣った魚をその場で出品して、ほしい時にほしい人に届ける魚専門セリアプリです
          </CopyArea>

          <p className="introduction_howto_sales_account--step">
            STEP4 割賦販売法に関する質問
          </p>
          <p>
            過去5年間に特定商取引法への違反や、消費者契約法違反による敗訴判決に該当がない場合は「いいえ」を選択してください。
          </p>
          <a href={Image_4} target="_blank" rel="noopener noreferrer">
            <img src={Image_4} loading="lazy" decoding="async" />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP5 入金のための口座を追加
          </p>
          <p>
            売上金を受け取る銀行口座を登録してください。
            <br />
            「口座名義」はカタカナで、Stripeに登録した氏名と一致するご本人名義の口座を入力してください。名義が一致しない場合、入金されません。
            <br />
            「入金スケジュール」はどちらを選択しても構いません（あとからStripeの管理画面で変更できます）。
          </p>
          <a href={Image_5} target="_blank" rel="noopener noreferrer">
            <img src={Image_5} loading="lazy" decoding="async" />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP6 顧客向けの表示情報
          </p>
          <p>
            「明細書表記」と「カスタマーサポート」には下記をコピーし入力してください。
          </p>
          <a href={Image_6} target="_blank" rel="noopener noreferrer">
            <img src={Image_6} loading="lazy" decoding="async" />
          </a>
          <CopyArea label="店舗名・サービス名">FishSale</CopyArea>
          <CopyArea>フィッシュセール</CopyArea>
          <CopyArea mb={16}>FISHSALE.JP</CopyArea>

          <CopyArea label="店舗名・サービス名（短縮版）">FishSale</CopyArea>
          <CopyArea>フィッシュセール</CopyArea>
          <CopyArea mb={16}>FISHSALE</CopyArea>

          <CopyArea mb={40} label="顧客サポート電話番号">
            05053576320
          </CopyArea>

          <p className="introduction_howto_sales_account--step">
            STEP7 Climate の寄付（オプション）
          </p>
          <p>
            気候変動対策への寄付は任意です。寄付をしない場合は「今はスキップ」を選択してください。
          </p>
          <a href={Image_7} target="_blank" rel="noopener noreferrer">
            <img src={Image_7} loading="lazy" decoding="async" />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP8 税額計算（オプション）
          </p>
          <p>
            Stripe Tax
            の利用は任意です。利用しない場合は「今はやめておく」を選択してください。
            <br />
            以上で登録は完了です。入力内容の確認画面が表示された場合は、内容を確認して送信してください。
          </p>
          <a href={Image_8} target="_blank" rel="noopener noreferrer">
            <img src={Image_8} loading="lazy" decoding="async" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default core;
